import { CheckoutService, BasketService, urls, HttpClient } from "pz-core";
export default class PzCheckoutProvider {
  constructor({ clearBasket = false, options = [] } = {}) {
    this.clearBasket = clearBasket;
    this.options = options;
    this.init();
  }

  async init() {
    const loaderDiv = document.createElement("div");
    const loaderWrapper = document.createElement("div");
    const loaderSpinner = document.createElement("div");

    loaderDiv.className = "checkout-provider-loader js-checkout-provider-loader";
    loaderWrapper.className = "checkout-provider-loader__wrapper";
    loaderSpinner.className = "checkout-provider-loader__spinner";

    loaderWrapper.appendChild(loaderSpinner);
    loaderDiv.appendChild(loaderWrapper);

    const { data } = await CheckoutService.getCheckoutProviders();
    const { page_context: pageContext } = data.context_list.find(
      (context) => context.page_slug === "checkoutproviderselectionpage"
    );

    pageContext.checkout_providers?.forEach((provider) => {
      document
        .querySelectorAll(".js-checkout-providers")
        .forEach((providersWrapper) => {
          const button = document.createElement("button");

          button.innerText = `Pay With ${provider.name}`;
          button.classList.add("pz-providers-quick-pay-button");

          this.options.forEach((item) => {
            if (item.slug === provider.slug) {
              if (item.options.title) {
                button.innerText = item.options.title;
              }

              if (item.options.className) {
                button.classList.add(item.options.className);
              }
            }
          });

          button.onclick = async (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.querySelector("body").append(loaderDiv);

            if (window.GLOBALS.page[0] !== "basket") {
              if (this.clearBasket) {
                await HttpClient.delete(urls.basket.base);
              }

              await BasketService.addProduct({
                product: providersWrapper.dataset.product,
                quantity: 1,
              });
              await CheckoutService.getCheckoutProviders();
            }

            const { data } = await CheckoutService.selectCheckoutProvider({
              checkout_provider: provider.pk,
            });
            const { page_context: pageContext } = data.context_list.find(
              (context) =>
                context.page_name === "CheckoutProviderAddressSelectionPage"
            );

            if (pageContext.redirect_url) {
              window.location.href = pageContext.redirect_url;
            }

            document.querySelector(".js-checkout-provider-loader").remove();
          };

          providersWrapper.appendChild(button);
        });
    });
  }
}
